import { getTestId, LILAC_300 } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  dataList: [{
    description: 'Here are a few testimonials from some of our customers which you might find interesting.',
    subtitle: 'Rohit, Jaipur'
  }, {
    description: 'Here are a few testimonials from some of our customers which you might find interesting.',
    subtitle: 'Rohit, Jaipur'
  }, {
    description: 'Here are a few testimonials from some of our customers which you might find interesting.',
    subtitle: 'Rohit, Jaipur'
  }, {
    description: 'Here are a few testimonials from some of our customers which you might find interesting.',
    subtitle: 'Rohit, Jaipur'
  }, {
    description: 'Here are a few testimonials from some of our customers which you might find interesting.',
    subtitle: 'Rohit, Jaipur'
  }, {
    description: 'Here are a few testimonials from some of our customers which you might find interesting.',
    subtitle: 'Rohit, Jaipur'
  }],
  backgroundColor: LILAC_300,
  breakPoints: {
    xs: {
      slidesPerPage: 1,
      slidesToScroll: 1,
      itemSpacing: 16,
      seekGap: 16,
      showNavigationCta: false
    },
    sm: {
      slidesPerPage: 2,
      slidesToScroll: 1,
      itemSpacing: 16,
      seekGap: 16,
      showNavigationCta: false
    },
    md: {
      slidesPerPage: 3,
      slidesToScroll: 1,
      itemSpacing: 16,
      seekGap: 16,
      showNavigationCta: false
    },
    lg: {
      slidesPerPage: 4,
      slidesToScroll: 1,
      itemSpacing: 24,
      seekGap: 16
    },
    xl: {
      slidesPerPage: 4,
      slidesToScroll: 1,
      itemSpacing: 24,
      seekGap: 16
    }
  }
}, getTestId('TestimonialWidgetContainer'));